export default __webpack_public_path__ + "static/media/moneymaker-r.efdb255f.webp";